import Http from '@/plugins/http.js';

export default {
    getWebPageList() {
        return Http.GET(`api/Site/GetWebPageList`);
    },
    setSitePageTemplate(templateId,state) {
        return Http.GET(`api/Site/SetSitePageTemplate/${templateId}/${state}`);
    },
    getPageTemplateState(templateId){
        return Http.GET(`api/Site/GetSitePageTemaplateState/${templateId}`);
    },
    getHomeGridsterById(id) {
        return Http.GET(`api/Site/GetHomeGridsterById/${id}`);
    },
    getListMyActiveApps() {
        return Http.GET(`api/App/GetListMyActiveApps`);
    },
    savePageTemplate(params, templateId, forApp = '') {
        if (forApp) {
            return Http.POST(`api/Site/SavePageTemplate/${templateId}/${forApp}`, params);
        } else {
            return Http.POST(`api/Site/SavePageTemplate/${templateId}`, params);
        }
    },
    getNavigatorConfig() {
        return Http.GET('api/Site/GetUserHomeNavigation');
    },
    saveNavigatorConfig(config) {
        return Http.POST('api/Site/SaveNavigation', config);
    },
    getSitePageBasicInfo(objectId) {
        return Http.GET(`api/Site/GetSitePageBasicInfo/${objectId}`);
    },
    addUserPageInfo(param) {
        return Http.POST('api/Site/AddUserPageInfo', param);
    },
    updateUserPageInfo(objectId, param) {
        return Http.POST(`api/Site/UpdateUserPageInfo/${objectId}`, param);
    },
    getSitePageDetailInfo(objectId) {
        return Http.GET(`api/Site/GetSitePageDetailInfo/${objectId}`);
    },
    deleteSitePage(objectId) {
        return Http.GET(`api/Site/DeleteSitePage/${objectId}`);
    },
    getNavigationById(objectId) {
        return Http.GET(`api/Site/GetNavigationById/${objectId}`);
    },
    saveNavigation(objectId, param) {
        return Http.POST(`api/Site/SaveNavigation/${objectId}`, param);
    },
};
